import {
  BlockOutlined,
  ScheduleOutlined,
  SnippetsOutlined
} from '@ant-design/icons'
import { useAppNavigate } from '@crm/hooks/useAppNavigate'
import { paths } from '@crm/routes'
import { getActivePath } from '@crm/utils'
import { Col, Menu, Row } from 'antd'

import { Status } from 'iconsax-react'
import { useTranslation } from 'react-i18next'
import { Outlet, useLocation } from 'react-router-dom'

import type { MenuProps } from 'antd/lib'

export const NomenclaturesTasks = () => {
  const { pathname } = useLocation()
  const { t } = useTranslation()
  const navigate = useAppNavigate()

  const items: MenuProps['items'] = [
    {
      key: paths.admin.nomenclatures.tasks.root,
      label: t('nomenclature.system_tasks'),
      icon: <ScheduleOutlined size={20} />,
      onClick: ({ key }) => navigate(key)
    },
    {
      key: paths.admin.nomenclatures.tasks.custom,
      label: t('nomenclature.custom_tasks'),
      icon: <SnippetsOutlined size={20} />,
      onClick: ({ key }) => navigate(key)
    },
    {
      key: paths.admin.nomenclatures.tasks.templates,
      label: t('nomenclature.templates_tasks'),
      icon: <BlockOutlined size={20} />,
      onClick: ({ key }) => navigate(key)
    },
    {
      key: paths.admin.nomenclatures.tasks.statuses,
      label: t('nomenclature.statuses'),
      icon: <Status size={16} />,
      onClick: ({ key }) => navigate(key)
    }
  ]

  return (
    <Row gutter={16} wrap={false}>
      <Col xs={8} lg={7} xl={6} xxl={5}>
        <Menu items={items} defaultSelectedKeys={[getActivePath(pathname)]} />
      </Col>

      <Col flex="auto">
        <Outlet />
      </Col>
    </Row>
  )
}
